// extracted by mini-css-extract-plugin
export default {"infoPanel":"NeedInvite_infoPanel__mPgFq","emphasis":"NeedInvite_emphasis__YlVcO"};